import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';

Amplify.configure(amplifyconfig);

createApp(App).use(store).use(router).mount('#app')
